<template>
  <vue-tel-input
    :class="clas"
    :placeholder="$t('Phone')"
    :value="value"
    :default-country="defaultCountry"
    :preferred-countries="preferredCountries"
    @input="checkPhone"
  ></vue-tel-input>
</template>
<script>
import { VueTelInput } from "vue-tel-input";

export default {
  name: "Telephone",
  props: {
    value: {
      type: String,
      default: ""
    },
    clas: {
      type: String,
      default: ""
    }
  },
  components: {
    VueTelInput
  },
  data() {
    return {
      defaultCountry: "US",
      preferredCountries: ["US", "IN"],
      phone: ""
    };
  },
  methods: {
    checkPhone: function(number, phoneObject) {
      if (phoneObject.number !== undefined) {
        this.phone = phoneObject.number;
      } else {
        this.phone = number;
      }
      this.$emit("input", this.phone);
    }
  }
};
</script>
<style scoped></style>
